export default __webpack_public_path__ + "static/media/longchamp35.f96e457b.jpg";